import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './IdogcamStatusBadge.module.scss';

interface IdogcamStatusBadgeProps {
    active: boolean;
    // Defaults to Active / Inactive (camera status); also used for Connected / Not connected.
    label?: string;
    className?: string;
}

export const IdogcamStatusBadge: FunctionComponent<IdogcamStatusBadgeProps> = ({ active, label, className }) => (
    <span className={clsx(styles.badge, active ? styles.active : styles.inactive, className)}>
        {label ?? (active ? 'Active' : 'Inactive')}
    </span>
);

export default IdogcamStatusBadge;
